<template>
  <div class="tinymce-container">
    <textarea class="tinymce-textarea" :id="id"></textarea>
    <div class="editor-custom-btn-container" v-if='isHide'>
      <!-- <div class="flex article-container">
        <el-input size="small" v-model="sourceUrl" placeholder="从链接获取"></el-input>
        <el-tooltip class="item" effect="dark" :content="tooltipText" placement="top-start">
          <el-button size="mini" type="success" icon="share" @click="syncArticle">同步</el-button>
        </el-tooltip>
      </div> -->
      <div class="flex" style="margin-top: 5px">
        <w-upload @callback="callbackUploadImage"></w-upload>
        <w-video @callback="callbackUploadVideo"></w-video>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Upload from 'base/upload'
import Video from 'base/video'

export default {
  components: {
    'w-upload': Upload,
    'w-video': Video
  },
  name: 'w-tinymce',
  props: {
    id: {
      type: String,
      default: 'tinymceEditor'
    },
    value: {
      type: String,
      default: ''
    },
    reInit: {
      type: Number,
      default: 0
    },
    customButton: {
      type: Array,
      required: false,
      default () {
        return ['editorImage']
      }
    },
    toolbar: {
      type: Array,
      required: false,
      default () {
        return ['removeformat undo redo | outdent indent | bullist numlist | forecolor | fullscreen code | h2 p',
          'bold italic blockquote | media link | alignleft aligncenter alignright | fontselect fontsizeselect']
      }
    },
    menubar: {
      default: 'edit insert view format table'
    },
    height: {
      type: Number,
      required: false,
      default: 360
    },
    isHide: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      sourceUrl: '',
      tooltipText: '微信打开想要同步的文章，复制地址到输入框中，点击“同步”即可同步内容'
    }
  },
  methods: {
    initTinymce () {
      const _this = this
      window.tinymce.init({
        selector: `#${this.id}`,
        height: this.height,
        body_class: 'panel-body ',
        object_resizing: false,
        language: 'zh_CN',
        language_url: '/static/tinymce1.3/langs/zh_CN.js',
        skin_url: '/static/tinymce/skins/lightgray',
        toolbar: this.toolbar,
        // 启用菜单栏并显示如下项 [文件 编辑 插入 格式 表格]
        menubar: this.menubar,
        // 配置每个菜单栏的子菜单项（如下是默认配置）
        menu: {
          // file: {title: 'File', items: 'newdocument'},
          edit: {title: 'Edit', items: 'undo redo | cut copy paste pastetext | selectall'},
          insert: {title: 'Insert', items: 'link media | template hr'},
          view: {title: 'View', items: 'visualaid'},
          format: {title: 'Format', items: 'bold italic underline strikethrough superscript subscript | formats | removeformat'},
          table: {title: 'Table', items: 'inserttable tableprops deletetable | cell row column'}
        },
        // 引入插件
        plugins: 'advlist,autolink,code,paste,textcolor, colorpicker,fullscreen,link,lists,media,wordcount, imagetools',
        // watermark
        end_container_on_empty_block: true,
        powerpaste_word_import: 'clean',
        code_dialog_height: 450,
        code_dialog_width: 1000,
        font_formats: "微软雅黑='微软雅黑';宋体='宋体';黑体='黑体';仿宋='仿宋';楷体='楷体';隶书='隶书';幼圆='幼圆';Andale Mono=andale mono,times;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;Comic Sans MS=comic sans ms,sans-serif;Courier New=courier new,courier;Georgia=georgia,palatino;Helvetica=helvetica;Impact=impact,chicago;Symbol=symbol;Tahoma=tahoma,arial,helvetica,sans-serif;Terminal=terminal,monaco;Times New Roman=times new roman,times;Trebuchet MS=trebuchet ms,geneva;Verdana=verdana,geneva;Webdings=webdings;Wingdings=wingdings",
        fontsize_formats: '8px 10px 12px 14px 16px 18px 24px 36px 48px 56px 72px',
        advlist_bullet_styles: 'square',
        advlist_number_styles: 'default',
        block_formats: '普通标签=p;小标题=h2;',
        imagetools_cors_hosts: ['wpimg.wallstcn.com', 'wallstreetcn.com'],
        imagetools_toolbar: 'watermark',
        default_link_target: '_blank',
        link_title: false,
        init_instance_callback: editor => {
          if (_this.value) {
            editor.setContent(_this.value)
          }
          editor.on('Change', () => {})
        },
        setup (editor) {
          editor.addButton('h2', {
            title: '小标题', // tooltip text seen on mouseover
            text: '小标题',
            onclick () {
              editor.execCommand('mceToggleFormat', false, 'h2')
            },
            onPostRender () {
              const btn = this
              editor.on('init', () => {
                editor.formatter.formatChanged('h2', state => {
                  btn.active(state)
                })
              })
            }
          })
          editor.addButton('p', {
            title: '正文',
            text: '正文',
            onclick () {
              editor.execCommand('mceToggleFormat', false, 'p')
            },
            onPostRender () {
              const btn = this
              editor.on('init', () => {
                editor.formatter.formatChanged('p', state => {
                  btn.active(state)
                })
              })
            }
          })
        }
      })
    },
    fetchArticle () {
      let config = {
        method: 'get',
        url: 'http://resource.huaxuezoo.com/syncArticle?url=' + encodeURI(this.sourceUrl).replace(/&/g, '%26').replace(/\+/g, '%2B').replace(/\s/g, '%20').replace(/#/g, '%23') + '&hash=' + new Date().getTime()
      }
      return axios(config).then(res => res.data).catch(err => { console.log(err) })
    },
    syncArticle () {
      if (this.sourceUrl.indexOf('http://') < 0 && this.sourceUrl.indexOf('https://') < 0) {
        this.sourceUrl = 'http://' + this.sourceUrl
      }
      this.fetchArticle().then(res => {
        this.sourceUrl = ''
        window.tinymce.get(this.id).setContent(res.data)
      })
    },
    callbackUploadImage (arr) {
      const _this = this
      arr.forEach(v => {
        const node = document.createElement('img')
        node.setAttribute('src', v.url)
        node.setAttribute('width', '100%')
        node.setAttribute('height', 'auto')
        node.onload = function () {
          window.$(this).addClass('wscnph')
          window.$(this).attr('data-wscntype', 'image')
          window.$(this).attr('data-wscnh', this.height)
          window.$(this).attr('data-wscnw', this.width)
          window.tinymce.get(_this.id).insertContent(node.outerHTML)
        }
      })
    },
    callbackUploadVideo (video) {
      const _this = this
      const node = document.createElement('video')
      node.setAttribute('src', video.videoUrl)
      node.setAttribute('poster', video.posterUrl)
      node.setAttribute('controls', 'controls')
      node.setAttribute('preload', 'none')
      node.setAttribute('width', '100%')
      node.setAttribute('height', 'auto')
      node.onload = function () {
        window.$(this).attr('style', 'object-fit: fill')
        window.$(this).attr('webkit-playsinline', 'true')
        window.$(this).attr('x-webkit-airplay', 'true')
        window.$(this).attr('playsinline', 'true')
        window.$(this).atrr('x5-video-orientation', 'h5')
        window.$(this).attr('x5-video-player-fullscreen', 'true')
      }
      window.tinymce.get(_this.id).insertContent(node.outerHTML)
    }
  },
  mounted () {
    // this.initTinymce()
    this.initTinymce({})
  },
  destroyed () {
    // 加上销毁 可让富文本在 跳转页面后，跳回之前页面 也能管用
    window.tinymce.get(this.id).destroy()
  }
}
</script>

<style>
  .mce-toolbar-grp {
    padding: 8px 0!important;
  }
  .tinymce-container {
    margin-right: 10px;
    position: relative;
  }
  .editor-custom-btn-container {
    position: absolute;
    right: 20px;
    top: 77px !important;
  }
  .article-container input {
    width: 300px;
    margin: 0px 10px 6px 0;
  }
  .article-container {
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/base/tinymce.vue